import { useMemo } from 'react';

import { DeviceType, Preview } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

export const StorePreview: React.FC<{
  previewProps: React.ComponentProps<typeof Preview>;
}> = ({ previewProps }) => {
  const isMobile = useMemo(
    () => previewProps.device === DeviceType.MOBILE,
    [previewProps]
  );

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg relative',
        isMobile
          ? 'mobile-preview w-[400px] h-5/6'
          : 'desktop-preview w-[85%] h-[85%] max-w-[1100px]'
      )}
      id="store-preview-wrapper"
    >
      <Preview {...previewProps} />
    </div>
  );
};
